import { EditorState, ContentState } from "draft-js";
import uuid from "react-native-uuid";
import store from "../../store";

import { DOCUMENTS, GRID } from "../../constants";

import {
  checkSectionIsTableV2GSheet,
  checkSectionIsLinkedToExcel,
  emptyTable,
  getUngroupedData,
  getDealTableColumns,
  emptyTextEditor,
} from "../../utils/documentUtils";

import getCompositeDecorator from "../CustomRevvEditor/decorator";

import { normaliseRowData, normaliseTableData } from "../../utils/tableUtils";
// import { getTableFieldStructure } from "../../utils/tableFieldUtils";

// import { getTableFieldStructure } from "../../utils/tableFieldUtils";

import { numberForamting } from "../../utils/globalUtils";

const { DOCUMENT_COMPONENT_TYPES, DEALTABLE_GROUPVIEW_HEADERS } = DOCUMENTS;
// const { CURRENCY_SYMBOL } = COMMON;
const { DEALTABLE_COLUMN_TYPES } = GRID;

export const getCellData = (tableData, rowID, columnID) => {
  let row;
  if (Array.isArray(tableData)) {
    row = tableData[rowID];
  } else {
    row = Array.isArray(tableData.data) ? tableData.data[rowID] : [];
  }

  let currentValue;
  if (Array.isArray(row)) {
    currentValue = { ...row[columnID] };
  } else {
    const { data } = row;
    currentValue = { ...data[columnID] };
  }
  return currentValue;
};

export const updateCellData = (tableData, rowID, colID, cellValue) => {
  let currentValue = getCellData(tableData, rowID, colID);

  if (currentValue && currentValue instanceof Object) {
    const { attributes } = currentValue;
    if (attributes.editable !== false) currentValue.data = cellValue;
  } else {
    currentValue = cellValue;
  }

  let allData = [];
  let updatedData = { ...tableData };
  if (Array.isArray(updatedData.data)) {
    allData = [...updatedData.data]; // table rows
  }
  if (allData.length > 0) {
    let tempRow = { ...allData[rowID] }; // specific table row
    const tempRowData = [...tempRow.data]; // specific table row colums
    tempRowData[colID] = { ...currentValue }; // specific table column
    tempRow = { ...tempRow, data: [...tempRowData] };
    allData[rowID] = { ...tempRow };
    updatedData = {
      ...tableData,
      attributes: { ...tableData.attributes },
      data: [...allData],
    };
  }
  return updatedData;
};

// export const updateCellData = (tableData, rowID, colID, cellValue) => {
//   const tempTableData = {...tableData};
//   let currentValue = getCellData(tableData, rowID, colID);

//   if (currentValue && currentValue instanceof Object) {
//     const { attributes } = currentValue;
//     if (attributes.editable !== false) currentValue.data = cellValue;
//   } else {
//     currentValue = cellValue;
//   }
//   const row = Array.isArray(tableData.data) ? tableData.data[rowID] : [];
//   const { data } = row;
//   data[colID] = currentValue;
//   return tableData;
// };

export const isTableActive = (section, activeID) => {
  const {
    data: { data: rowData },
    id,
  } = section;
  if (!Array.isArray(rowData)) return false;
  if (id === activeID) return true;
  for (let i = 0; i < rowData.length; i += 1) {
    const row = rowData[i];
    if (Array.isArray(row.data)) {
      for (let j = 0; j < row.data.length; j += 1) {
        const cell = row.data[j];
        if (cell.attributes.id === activeID) return true;
      }
    }
  }
  return false;
};

export const getCell = (components, componentMeta, tableId, rowId, colId) => {
  const { blockType } = componentMeta;
  if (blockType === "BODY" && tableId && components[tableId]) {
    return components[tableId].content.data.data[rowId].data[colId];
  }
  if (blockType === "FOOTER") {
    const { footerId } = componentMeta;
    if (
      components[footerId] &&
      components[footerId].content &&
      components[footerId].content.data.footer.components[tableId] &&
      components[footerId].content.data.footer.components[tableId].content.data
        .data[rowId] &&
      components[footerId].content.data.footer.components[tableId].content.data
        .data[rowId].data[colId]
    )
      return components[footerId].content.data.footer.components[tableId]
        .content.data.data[rowId].data[colId];
  }
  if (blockType === "HEADER") {
    const { headerId } = componentMeta;
    if (
      components[headerId] &&
      components[headerId].content &&
      components[headerId].content.data.header.components[tableId] &&
      components[headerId].content.data.header.components[tableId].content.data
        .data[rowId] &&
      components[headerId].content.data.header.components[tableId].content.data
        .data[rowId].data[colId]
    )
      return components[headerId].content.data.header.components[tableId]
        .content.data.data[rowId].data[colId];
  }
  if (blockType === "COVERPAGE") {
    const { coverpageId } = componentMeta;
    if (
      components[coverpageId] &&
      components[coverpageId].content &&
      components[coverpageId].content.data.components[tableId] &&
      components[coverpageId].content.data.components[tableId].content.data
        .data[rowId] &&
      components[coverpageId].content.data.components[tableId].content.data
        .data[rowId].data[colId]
    )
      return components[coverpageId].content.data.components[tableId].content
        .data.data[rowId].data[colId];
  }

  return null;
};

export const convertSectionTableToGSheet = section => {
  const dummyTable = emptyTable("DOCUMENT", 2);
  const reduxState = store.getState();
  const { components } = reduxState.DocumentStore;
  const sectionList = Object.values(components);
  const label = `Linked Google Sheet ${
    sectionList.filter(
      sec =>
        checkSectionIsTableV2GSheet(sec) ||
        sec.content.type === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET,
    ).length + 1
  }`;
  const tableData = {
    data: dummyTable.data.data,
    attributes: {
      ...section.content.data.attributes,
      dataSource: "GoogleSheet",
      showRowOptions: false,
      showColumnOptions: false,
      showGSheetLable: true,
      readOnly: true,
      isLinkedToDataSource: true,
      editable: false,
      showManageColumnOption: true,
      sheet: {},
      workSheet: "",
      rangeValue: "",
      autoTrim: false,
      connected: false,
      hiddenCols: [],
      label,
      firstRowAsHeader: true,
    },
  };
  return tableData;
};

export const convertSectionTableToTableApi = (
  tableSchemaData,
  isUnlinkedTableApi,
  tableAPIFieldId,
) => {
  const {
    table_schema: tableSchema,
    table_rows: tableRows,
    column_order: columnOrder,
    table_type: tableType,
    table_meta: tableMeta,
  } = tableSchemaData;
  const { label_map: labelMap } = tableSchema;
  const convertedTableData = [];
  const tableHeaderData = [];
  let tableRowData = [];
  const tableColumnDefs = [];

  // calculating column defs
  columnOrder.map(colId => tableColumnDefs.push({ id: colId }));

  // Converting table header data
  columnOrder.map(colId =>
    tableHeaderData.push({
      data: {
        data:
          labelMap[colId].rich && labelMap[colId].rich.blocks
            ? labelMap[colId].rich
            : ContentState.createFromText(labelMap[colId].text),
      },
      attributes: {
        editable: !isUnlinkedTableApi,
        id: colId,
        headerCellId: `${tableAPIFieldId}_${colId}`,
        bgColor:
          tableType === "TABLE_DOCUMENT"
            ? `${
                labelMap[colId].cell_meta
                  ? labelMap[colId].cell_meta.bgColor
                  : " "
              }`
            : "#F4F5F7",
      },
    }),
  );

  convertedTableData.push({
    attributes: { columnCount: columnOrder.length, id: "header" },
    data: tableHeaderData,
  });

  // Converting table row data
  if (Array.isArray(tableRows) && tableRows.length > 0) {
    tableRows.forEach(row => {
      const { row_data: rowData, row_id: rowId } = row;
      columnOrder.map(colId =>
        tableRowData.push({
          data: {
            data:
              rowData[colId].rich && rowData[colId].rich.blocks
                ? rowData[colId].rich
                : ContentState.createFromText(rowData[colId].text),
          },
          attributes: {
            id: `${rowId}_${colId}`,
            headerCellId: `${tableAPIFieldId}_${rowId}_${colId}`,
            bgColor:
              rowData[colId].cell_meta && rowData[colId].cell_meta.bgColor
                ? rowData[colId].cell_meta.bgColor
                : "",
          },
        }),
      );
      convertedTableData.push({
        attributes: { columnCount: columnOrder.length, id: rowId },
        data: tableRowData,
      });
      tableRowData = [];
    });
  }
  let appliedBorderColor = "";
  let columnWidths = [];
  if (tableMeta && tableMeta.borderColor) {
    appliedBorderColor = tableMeta.borderColor;
  }
  if (tableMeta && tableMeta.columnWidth) {
    columnWidths = tableMeta.columnWidth;
  } else {
    columnWidths = Array(columnOrder.length).fill("100px");
  }

  const tableData = {
    data: convertedTableData,
    attributes: {
      dataSource: "TableApi",
      showRowOptions: false,
      showColumnOptions: false,
      showGSheetLable: true,
      showColorStyles: true,
      isSelectionAllowed: true,
      isLinkedToDataSource: true,
      showManageColumnOption: true,
      sheet: {},
      workSheet: "",
      rangeValue: "",
      autoTrim: false,
      connected: false,
      hiddenCols: [],
      className: "revv-table",
      colResize: true,
      summary: false,
      allowRowRearrange: false,
      allowColRearrange: true,
      isTableADynamicField: false,
      firstRowAsHeader: true,
      columnWidth: columnWidths,
      columnCount: columnOrder.length,
      rowCount: convertedTableData.length,
      isUnlinkedTableDocument:
        tableType === "TABLE_DOCUMENT" && isUnlinkedTableApi,
      tableColumnDefs,
      borderColor: appliedBorderColor,
    },
  };
  return tableData;
};

export const getColAndRowCountFromRange = range => {
  const tempVal = range.match(/[a-zA-Z]+|[0-9]+/g);
  // let columnCount = null;
  // eslint-disable-next-line radix
  const startRow = parseInt(tempVal[1]) - 1;
  // eslint-disable-next-line radix
  const endRow = parseInt(tempVal[3]) - 1;
  // const rowCount = parseInt(tempVal[1]);
  let startCol = null;
  let endCol = null;
  for (let i = 0; i < tempVal[0].length; i += 1) {
    startCol =
      (startCol === null ? 0 : startCol + 1) * 26 +
      (tempVal[0].charCodeAt(i) - 65);
  }
  for (let i = 0; i < tempVal[2].length; i += 1) {
    endCol =
      (endCol === null ? 0 : endCol + 1) * 26 + (tempVal[2].charCodeAt(i) - 65);
  }

  const rowColValues = {
    startRow,
    endRow,
    startCol,
    endCol,
  };
  return rowColValues;
};

export const getTableDataFromExcel = (
  excelData,
  startRow,
  endRow,
  startCol,
  endCol,
  rowCount,
  colCount,
  firstRowAsHeader,
) => {
  const tableRowsData = [];
  if (colCount > 26) colCount = 26;
  if (rowCount > 50) rowCount = 50;
  for (let i = startRow; i <= endRow && i < startRow + rowCount; i += 1) {
    const tableColsData = [];
    for (let j = startCol; j <= endCol && j < startCol + colCount; j += 1) {
      if (
        excelData.length > 0 &&
        excelData[i][j] !== undefined &&
        excelData[i][j] !== null
      ) {
        tableColsData.push({
          attributes: { id: uuid.v4() },
          data: {
            data: ContentState.createFromText(excelData[i][j].toString()),
            editorState: EditorState.createWithContent(
              ContentState.createFromText(excelData[i][j].toString()),
              getCompositeDecorator(),
            ),
          },
        });
      } else {
        tableColsData.push({
          attributes: { id: uuid.v4() },
          data: { ...emptyTextEditor("DOCUMENT", "", false) },
        });
      }
    }
    if (i === startRow && firstRowAsHeader) {
      tableRowsData.push({
        attributes: { columnCount: colCount, id: uuid.v4(), header: true },
        data: tableColsData,
      });
    } else {
      tableRowsData.push({
        attributes: { columnCount: colCount, id: uuid.v4() },
        data: tableColsData,
      });
    }
  }

  const updatedTableData = {
    attributes: {
      columnCount: colCount,
      rowCount,
      originalColumnCount: colCount,
      originalRowCount: rowCount,
      tableColumnDefs: Array(colCount)
        .fill()
        .map(() => Object({ id: uuid.v4() })),
      columnWidth: Array(colCount).fill("100px"),
    },
    data: tableRowsData,
  };
  return updatedTableData;
};

export const convertExcelToSectionTable = (
  section,
  excelData,
  currSheetName,
  selectedRangeValue,
  firstRowAsHeader,
) => {
  let rangeVal = null;
  let sheetData = null;
  let autoTrim = false;
  if (selectedRangeValue) {
    rangeVal = selectedRangeValue;
  }
  excelData.forEach(sheet => {
    if (currSheetName === sheet.sheetName) {
      sheetData = sheet.data;
      if (!rangeVal) rangeVal = sheet.range;
    }
  });
  const { startRow, endRow, startCol, endCol } =
    getColAndRowCountFromRange(rangeVal);

  const columnCount = endCol - startCol + 1;
  const rowCount = endRow - startRow + 1;

  const updatedTableData = getTableDataFromExcel(
    sheetData,
    startRow,
    endRow,
    startCol,
    endCol,
    rowCount,
    columnCount,
    firstRowAsHeader,
  );

  if (columnCount >= 26 || rowCount >= 50) {
    rangeVal = "A1:Z50";
    autoTrim = true;
  }
  const tableData = {
    data: updatedTableData.data,
    attributes: {
      ...updatedTableData.attributes,
      dataSource: "ExcelTable",
      showRowOptions: false,
      showColumnOptions: false,
      showGSheetLable: true,
      readOnly: false,
      isLinkedToDataSource: true,
      connected: true,
      editable: true,
      showManageColumnOption: true,
      sheet: sheetData,
      currentSheetName: currSheetName,
      workSheet: "",
      rangeValue: rangeVal,
      autoTrim,
      hiddenCols: [],
      excelSheets: excelData,
      label: section.data.attributes.label,
      firstRowAsHeader,
    },
  };
  return tableData;
};

export const convertSectionTableToLinkedExcel = (
  section,
  excelData,
  isChangingFileForSameTable,
) => {
  const dummyTable = emptyTable("DOCUMENT", 2);
  const reduxState = store.getState();
  const { components } = reduxState.DocumentStore;
  const sectionList = Object.values(components);
  let { label } = section.data.attributes;
  if (!isChangingFileForSameTable) {
    label = `Uploaded xls ${
      sectionList.filter(sec => checkSectionIsLinkedToExcel(sec)).length + 1
    }`;
  }
  const tableData = {
    // data: updatedTableData.data,
    data: dummyTable.data.data,
    attributes: {
      ...section.data.attributes,
      dataSource: "ExcelTable",
      showRowOptions: false,
      showColumnOptions: false,
      showGSheetLable: true,
      readOnly: true,
      isLinkedToDataSource: true,
      connected: false,
      editable: false,
      showManageColumnOption: true,
      sheet: {},
      workSheet: "",
      rangeValue: "",
      autoTrim: false,
      hiddenCols: [],
      excelSheets: excelData,
      currentSheetName: excelData[0].sheetName,
      label,
      firstRowAsHeader: false,
    },
  };
  return tableData;
};

export const UnlinkSectionTableWithExcel = section => {
  const updatedTable = {
    data: section.data.data,
    attributes: {
      ...section.data.attributes,
      dataSource: "",
      editable: true,
      showRowOptions: true,
      showColumnOptions: true,
      showGSheetLable: false,
      readOnly: false,
      isLinkedToDataSource: false,
      showManageColumnOption: false,
      sheet: {},
      workSheet: "",
      rangeValue: "",
      autoTrim: false,
      connected: false,
      currentSheetName: "",
      excelSheets: [],
    },
  };
  return updatedTable;
};

export const convertSectionTableToQuoteTable = section => {
  const dummyTable = emptyTable("DOCUMENT", 2);
  const tableData = {
    data: dummyTable.data.data,
    attributes: {
      ...section.content.data.attributes,
      dataSource: "DealTable",
      readOnly: true,
      isLinkedToDataSource: true,
      editable: false,
      showRowOptions: false,
      showColumnOptions: false,
      showManageColumnOption: true,
    },
  };
  return tableData;
};

export const convertLinkedGsheettoTable = section => {
  section.content.data.data.forEach(row => {
    row.data.forEach(col => {
      if (col.data === "") {
        col.data = {
          ...emptyTextEditor("DOCUMENT", "", false),
        };
      }
    });
  });
  const updatedTable = {
    data: section.content.data.data,
    attributes: {
      ...section.content.data.attributes,
      dataSource: "",
      editable: true,
      showRowOptions: true,
      showColumnOptions: true,
      showGSheetLable: false,
      readOnly: false,
      isLinkedToDataSource: false,
      showManageColumnOption: false,
      sheet: {},
      workSheet: "",
      rangeValue: "",
      autoTrim: false,
      connected: false,
    },
  };
  return updatedTable;
};

export const convertLinkedQuotetoTable = section => {
  const { isLinkedToDataSource, connected } = section.content.data.attributes;
  if (isLinkedToDataSource && connected)
    section.content.data.data.forEach(row => {
      row.data.forEach(col => {
        const cellData = ContentState.createFromText(col.data.toString());

        col.data = {
          data: cellData,
          editorState: EditorState.createWithContent(
            cellData,
            getCompositeDecorator(),
          ),
        };
      });
    });
  const tableData = {
    data: section.content.data.data,
    attributes: {
      ...section.content.data.attributes,
      dataSource: "",
      editable: true,
      showRowOptions: true,
      showColumnOptions: true,
      showGSheetLable: false,
      readOnly: false,
      isLinkedToDataSource: false,
      showManageColumnOption: false,
      summary: false,
      connected: false,
    },
  };
  return tableData;
};

export const convertSectionTableForPlaceholder = section => {
  const tableData = {
    data: section.data.data,
    attributes: {
      ...section.data.attributes,
      showRowOptions: false,
      showColumnOptions: false,
      readOnly: true,
      editable: false,
      showDataSourceOption: false,
      showManageColumnOption: true,
      showColorStyles: false,
    },
  };
  return tableData;
};

export const checkTableDataSourceType = tableData => {
  if (tableData && tableData.attributes) {
    const { dataSource } = tableData.attributes;
    if (dataSource === "DealTable" || dataSource === "QuoteTable")
      return "QuoteTable";

    if (dataSource === "GoogleSheet") return "GoogleSheet";
  }
  return null;
};

export const getQuoteTableData = (
  tableData,
  dealTableId,
  currency,
  metaData,
  rowData,
  discount,
  columnDefs,
) => {
  const { attributes } = tableData;
  const { tableColumnDefs } = attributes;
  // columnDefs = columnDefs.filter(col => col.hidden === undefined);
  // check if it is attached to a quotetable or not
  if (
    !(
      attributes.isLinkedToDataSource &&
      checkTableDataSourceType(tableData) === "QuoteTable"
    )
  )
    return null;

  // check if it is attached and connected
  if (!dealTableId) return [];

  let newTableColumnDefs = tableColumnDefs || [];
  if (tableColumnDefs && tableColumnDefs.length !== columnDefs.length) {
    newTableColumnDefs = [];
    columnDefs.forEach(row => {
      if (row.columnId) {
        newTableColumnDefs.push({ id: row.columnId });
      } else {
        newTableColumnDefs.push({ id: 1 });
      }
    });
  }

  // const newColumnDefs = newTableColumnDefs || columnDefs;

  const updatedColumnDefs = new Array(columnDefs.length);
  newTableColumnDefs.forEach((row, index) => {
    let findRow;
    columnDefs.forEach(tableRow => {
      if (tableRow.columnId === row.id) {
        findRow = tableRow;
      } else if (tableRow.columnId === undefined && row.id) {
        findRow = tableRow;
      }
    });
    updatedColumnDefs[index] = findRow;
  });

  const { viewMode: dealTableView } = tableData.attributes;
  let headers;
  let quoteTableData;
  let groupByIndex;
  let groupSummary;
  if (
    !dealTableView ||
    dealTableView === "NORMAL_VIEW" ||
    dealTableView === "GROUPED_VIEW"
  ) {
    // get headers text using column defs
    headers = updatedColumnDefs.map(column => column.headerName);

    // get raw row data for each product catalog added
    const ungroupedData = getUngroupedData(
      metaData,
      rowData,
      updatedColumnDefs,
    );

    // get raw data with number formating to covert cell data with currency added to it.
    const viewData = ungroupedData.map(row =>
      row.map((cell, index) => {
        if (
          updatedColumnDefs[index].type === DEALTABLE_COLUMN_TYPES.CurrencyField
        ) {
          return numberForamting(cell, currency);
        }
        if (typeof cell === "number") return cell.toString();
        return cell;
      }),
    );

    // attach each row with row id, so that it could be assignned to row attributes for future use

    const quoteRowTableData = rowData.map((row, rowIndex) => ({
      id: row.rowMeta.id.toString(),
      value: viewData[rowIndex],
    }));

    // now check if this is a group view
    if (
      dealTableView === "GROUPED_VIEW" &&
      Array.isArray(discount.groups) &&
      discount.groups.length > 0
    ) {
      // the grouping column index. In future we should be able to group by any column we want
      groupByIndex = updatedColumnDefs.findIndex(
        col => col.name === discount.groups[0].group_by.toLowerCase(),
      );
      quoteTableData = [];
      groupSummary = {};
      discount.groups.forEach(group => {
        const groupRows = quoteRowTableData.filter(
          row => row.value[groupByIndex] === group.group_by_value,
        );
        if (Array.isArray(groupRows) && groupRows.length > 0) {
          quoteTableData.push(
            { id: `${group.group_by_value}-header`, value: headers },
            ...groupRows,
          );
        }
        groupSummary[group.group_by_value] = [
          {
            label: `${group.group_by_value} Subtotal`,
            value: numberForamting(group.group_total, currency),
          },
          {
            label: "Discount (%)",
            value: group.discount_percent,
          },
          {
            label: "Discount Value",
            value: numberForamting(group.discountAmount, currency),
          },
          {
            label: "Total",
            value: numberForamting(group.discountedGroupTotal, currency),
          },
        ];
      });
    } else {
      quoteTableData = [{ id: "header", value: headers }, ...quoteRowTableData];
    }
    // now check if the table is attached to quotetable and is in a normal view
  } else if (dealTableView === "GROUP_SUMMARY_VIEW") {
    headers = DEALTABLE_GROUPVIEW_HEADERS.map(column => column.label);
    const quoteRowTableData = Array.isArray(discount.groups)
      ? discount.groups.map(column => ({
          id: column.id ? column.id.toString() : column.group_by_value,
          value: DEALTABLE_GROUPVIEW_HEADERS.map(cell =>
            typeof column[cell.key] === "number"
              ? column[cell.key].toString()
              : column[cell.key],
          ),
        }))
      : [];

    quoteTableData = [{ id: "header", value: headers }, ...quoteRowTableData];
  }
  // quoteTableData.tableColumnDefs = [...newTableColumnDefs];

  const summaryDetails = [
    {
      label: "Subtotal",
      value: numberForamting(discount.dealTotal, currency),
    },
    {
      label: "Quote Discount (%)",
      value: discount.deal_discount,
    },
    {
      label: "Quote Discount Value",
      value: numberForamting(discount.discountAmount, currency),
    },
    {
      label: "Quote Total",
      value: numberForamting(discount.discountedDealTotal, currency),
    },
  ];
  return {
    quoteTableData,
    summaryDetails,
    groupByIndex,
    headers,
    groupSummary,
  };
};

export const updateCellValue = (rowData, tableData) => {
  const { attributes, data: tableRowData } = tableData;
  // check if both have same number of rows

  if (
    !(
      attributes.rowCount === rowData.length &&
      attributes.columnCount === rowData[0].value.length
    )
  ) {
    const updatedTableData = normaliseTableData(rowData.map(row => row.value));
    updatedTableData.data.forEach((row, rowIndex) => {
      row.attributes = {
        ...row.attributes,
        id: rowData[rowIndex].id.toString(),
      };
      if (
        typeof rowData[rowIndex].id === "string" &&
        rowData[rowIndex].id.includes("header")
      ) {
        row.attributes.header = true;
      }
    });

    // copy attributes if both are of same view
    if (
      updatedTableData.attributes.columnCount ===
      tableData.attributes.columnCount
    ) {
      updatedTableData.attributes = {
        ...tableData.attributes,
        rowCount: updatedTableData.attributes.rowCount,
      };
    }
    return updatedTableData;
  }

  const updatedRowData = new Array(tableRowData.length);
  tableRowData.forEach((row, index) => {
    let findRow;
    rowData.forEach(tableRow => {
      if (tableRow.id === row.attributes.id) {
        findRow = row;
      }
    });
    if (!findRow) {
      findRow = normaliseRowData(rowData[index].value);
      findRow.attributes.id = rowData[index].id;
    } else {
      findRow.data = findRow.data.map((cell, rowIndex) => ({
        ...cell,
        data: row.data[rowIndex].data,
      }));
    }
    if (
      typeof row.attributes.id === "string" &&
      row.attributes.id.includes("header")
    ) {
      findRow.attributes.header = true;
    }
    updatedRowData[index] = findRow;
  });

  return {
    ...tableData,
    data: updatedRowData,
  };
};

export const getQuoteTableAdapaterData = (
  tableData,
  dealTableId,
  currency,
  metaData,
  rowData,
  discount,
  columnDefs,
) => {
  if (!(Array.isArray(rowData) && rowData.length !== 0)) {
    return tableData;
  }

  const tableDetails = getQuoteTableData(
    tableData,
    dealTableId,
    currency,
    metaData,
    rowData,
    discount,
    columnDefs,
  );
  if (!tableDetails) return tableData;

  const updatedTableData = updateCellValue(
    tableDetails.quoteTableData,
    tableData,
  );

  updatedTableData.attributes.viewMode = tableData.attributes.viewMode;

  // // mark first row as header
  // updatedTableData.data[0].attributes.header = true;

  // add conneted flag
  updatedTableData.attributes.connected = true;

  // apply summary details
  updatedTableData.attributes.summaryDetails = tableDetails.summaryDetails;

  if (tableDetails.groupByIndex) {
    updatedTableData.attributes.groupByIndex = tableDetails.groupByIndex;
    updatedTableData.attributes.groups = discount.groups;
    updatedTableData.attributes.groupSummary = tableDetails.groupSummary;
  }
  // check hidden columns
  if (
    !(
      Array.isArray(updatedTableData.attributes.hiddenCols) &&
      updatedTableData.attributes.hiddenCols.length > 0
    ) &&
    tableData.attributes.viewMode !== "GROUP_SUMMARY_VIEW"
  ) {
    const dealTableColumns = getDealTableColumns(columnDefs).map(
      col => col.name,
    );
    const hiddenColumns = [];
    columnDefs.forEach((col, index) => {
      if (!dealTableColumns.includes(col.name)) hiddenColumns.push(index);
    });
    updatedTableData.attributes.hiddenCols = hiddenColumns;
  }

  const allowModeSelection =
    discount && Array.isArray(discount.groups) && discount.groups.length > 0;

  updatedTableData.attributes.allowModeSelection = allowModeSelection;

  if (tableData.attributes.viewMode === "GROUPED_VIEW") {
    updatedTableData.attributes.allowRowRearrange = false;
    updatedTableData.attributes.allowColRearrange = false;
  } else {
    updatedTableData.attributes.allowRowRearrange = true;
    updatedTableData.attributes.allowColRearrange = true;
  }

  return updatedTableData;
};

export const isTableCellMerged = cell => {
  if (
    cell &&
    Object.prototype.hasOwnProperty.call(cell.attributes, "colspan") &&
    parseInt(cell.attributes.colspan, 10) > 1
  ) {
    return true;
  }
  return false;
};
